import React from 'react';
import { Col, Layout, message, Row, DatePicker } from 'antd';
import moment from "moment";
import MiCompAPI from "../../util/api";
import ReportTableWrapper from "../elements/ReportTableWrapper";
import ExportJsonExcel from 'js-export-excel';
const { Content } = Layout;
class BrokerAgencyRecon extends React.Component {
    columns = [{
        title: 'Broker/Agency Id',
        dataIndex: 'entity_id',
        sorter: (a, b) => a.entity_id-b.entity_id,
        sortDirections: ["descend", "ascend"]
    }, {
        title: 'Broker/Agency Name',
        dataIndex: 'name',
        sorter: (a, b) => a.name.localeCompare(b.name),
        sortDirections: ["descend", "ascend"]
    },
    {
        title: 'Net Amount',
        dataIndex: 'net_amt',
        render: (text, record) => "$" + record["net_amt"],
        sorter: (a, b) => a.net_amt-b.net_amt,
        sortDirections: ["descend", "ascend"],
        align: 'right'
    },
    {
        title: 'Tax Amount',
        dataIndex: 'tax_amt',
        render: (text, record) => "$" + record["tax_amt"],
        sorter: (a, b) => a.tax_amt-b.tax_amt,
        sortDirections: ["descend", "ascend"],
        align: 'right'
    },
    {
        title: 'Paid Amount',
        dataIndex: 'paid_amt',
        render: (text, record) => "$" + record["paid_amt"],
        sorter: (a, b) => a.paid_amt-b.paid_amt,
        sortDirections: ["descend", "ascend"],
        align: 'right'
    }, {
        title: 'Variance',
        dataIndex: 'varience_Amount',
        render: (text, record) => "$" + record["varience_Amount"],
        sorter: (a, b) => a.varience_Amount-b.varience_Amount,
        sortDirections: ["descend", "ascend"],
        align: 'right'
    }];
    constructor(props) {
        super(props);
        this.state = {
            reconreport: null,
            isLoading: false,
            from_date: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
            to_Date: new Date(),
        }
        this.tableButtons = [{
            buttonType: "primary",
            content: "Export Excel",
            clickHandler: () => {
                this.downloadExcel();
            }
        }];
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    downloadExcel = () => {
        const data = this.state.reconreport.user_Summary ? this.state.reconreport.user_Summary : '';//tabular data
        var option = {};
        let dataTable = [];
        if (data) {
            for (let i in data) {
                if (data) {
                    let obj = {
                        'Broker/Agency ID': data[i].entity_id,
                        'Broker/Agency Name': data[i].name,
                        'Paid Amount': "$" + data[i].paid_amt,
                        'Tax Amount': "$" + data[i].tax_amt,
                        'Net Amount': "$" + data[i].net_amt,
                        'Variance': "$" + data[i].varience_Amount,
                    }
                    dataTable.push(obj);
                }
            }
        }
        option.fileName = 'BrokerAgencyRecon'
        option.datas = [
            {
                sheetData: dataTable,
                sheetName: 'sheet',
                sheetFilter: ['Broker/Agency ID', 'Broker/Agency Name', 'Paid Amount', 'Tax Amount', 'Net Amount', 'Variance'],
                sheetHeader: ['Broker/Agency ID', 'Broker/Agency Name', 'Paid Amount', 'Tax Amount', 'Net Amount', 'Variance'],
            }
        ];
        if(dataTable.length>0){
            var toExcel = new ExportJsonExcel(option);
            toExcel.saveExcel();
        }
    }
    componentDidMount = () => {
this.GetReconciliation(this.state.from_date,this.state.to_Date);
    }
    onChange = (type, e) => {
        if (type === 'from') {
            this.setState({
                from_date: e
            })
        }
        if (type === 'to') {
            this.setState({
                to_Date: e
            })
        }
        setTimeout(() => {
            if(this.state.from_date&&this.state.to_Date){
this.GetReconciliation(this.state.from_date,this.state.to_Date);
            }
        }, 100);
    }
    GetReconciliation(from_date,to_date) {
        this.setState({
            isLoading: true
        })
        var data = { from_Date: from_date, to_Date: to_date }
        this.api.invoke(
            "GetReconciliation",
            "post",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.setState({
                            isLoading: false,
                            reconreport: data.data
                        })
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            }, data);
    }
    render() {
        return (
            <Content>
                <div className="mi_main_div">
                    <Row style={{ padding: '20px', background: 'white' }}>
                        <Col span={24}>
                            <p className="mi_table_title" style={{ textAlign: 'center', marginBottom: '40px' }}>Broker/Agency Commission Reconciliation Report</p>
                        </Col>
                        <Col span={24} style={{ marginBottom: '0px' }}>
                            <Row span={24}>
                                <Col span={12} >
                                    <fieldset className="mi_input_pop">
                                        <legend className="legend-font">From Date : </legend>
                                        <DatePicker defaultValue={moment(this.state.from_date,"MM/DD/YYYY")?moment(this.state.from_date,"MM/DD/YYYY"):undefined} format="MM/DD/YYYY" autoComplete={"nope"}  onChange={this.onChange.bind(this, 'from')} style={{ width: '100%' }} />
                                    </fieldset>
                                </Col>
                                <Col span={12} >
                                    <fieldset className="mi_input_pop">
                                        <legend className="legend-font"> To Date : </legend>
                                        <DatePicker autoComplete={"nope"}  defaultValue={moment(this.state.to_Date,"MM/DD/YYYY")?moment(this.state.to_Date,"MM/DD/YYYY"):undefined} format="MM/DD/YYYY" onChange={this.onChange.bind(this, 'to')} style={{ width: '100%' }} />
                                    </fieldset>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <ReportTableWrapper rowKey="policy_id" columns={this.columns} data={this.state.reconreport ? this.state.reconreport.user_Summary : null} loading={this.state.isLoading} buttons={this.tableButtons} search={true} />
                        </Col>
                        <Col span={24}>
                            <Row style={{ width: '300px', float: 'right', marginTop: '20px' }}>
                                <Col span={24}>
                                    <Row span={24}>
                                        <Col span={12} className='footertext'>Paid Amount:	</Col>
                                        <Col span={12} className='footertext'>{this.state.reconreport&&this.state.reconreport.paid_amt  ? "$" + this.state.reconreport.paid_amt : "$0"}</Col>
                                    </Row>
                                    <Row span={24}>
                                        <Col span={12} className='footertext'>Net Amount:	</Col>
                                        <Col span={12} className='footertext'>{this.state.reconreport&&this.state.reconreport.net_amt ? "$" + this.state.reconreport.net_amt : "$0"}</Col>
                                    </Row>
                                    <Row span={24}>
                                        <Col span={12} className='footertext'>Variance:	</Col>
                                        <Col span={12} className='footertext'>{this.state.reconreport&&this.state.reconreport.varience_Amount ? "$" + this.state.reconreport.varience_Amount : "$0"}</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Content>
        );
    }
}
export default BrokerAgencyRecon;